import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "../../../../actions/game-instance-actions";
import GameComponent from '../../../game/game-component';
import GameInstance from "common/models/game-instance";

class SummaryTable extends GameComponent {

    locale = 'cs-CZ';
    months = [1,2,3,4,5,6,7,8,9,10,11,12];

    constructor(params) {
        super(params);
        this.state = {
            instanceId: null,
            money: []
        }
    }

    componentWillMount() {
        const instanceId = this.props.gameInstance.instance.id;
        this.setState({...this.state, instanceId: instanceId});
    }

    moneyItemForMonth = (item, month) => {
        return item.months.includes(month) ? Number(item.amount) : 0;
    };

    formatValue(value) {
        if (value < 0) {
            return (<span className='text-danger'>{ value.toLocaleString(this.locale) }</span>)
        } else {
            return (<span>{ value.toLocaleString(this.locale) }</span>)
        }
    }

    tableRows = (filter) => {
        return this.props.money.filter(filter).map((item, index) => {
            let rowData = this.tableRowValues(item);
            return (
                <tr key={index}>
                    <td style={{'whiteSpace':'pre-wrap'}}>{ item['category'] && <span>{GameInstance.getCategoryTitle(item['category'])}<br/></span> }{ item['name'] }</td>
                    <td></td>
                    { rowData.row }
                    <td>{ this.formatValue(rowData.sum) }</td>
                </tr>
            );
        });
    };

    tableSumRow = (name, filter) => {
        let sum = 0;
        let filteredItems = this.props.money.filter(filter);
        let months = this.months.map((month) => {
            let value = filteredItems.reduce((sum, item) => { return (sum + this.moneyItemForMonth(item, month)) }, 0);
            sum += value;
            return (
                <th key={month}>{ this.formatValue(Number(value)) }</th>
            );
        });

        return (
            <tr>
                <th style={{'whiteSpace':'pre-wrap'}}>{name}</th>
                <th></th>
                { months }
                <th>{ this.formatValue(sum) }</th>
            </tr>
        )
    };

    tableRowValues = (item) => {
        let sum = 0;
        return {
            row: this.months.map((month) => {
                let value = this.moneyItemForMonth(item, month);
                sum += value;
                return (<td key={month}>{ this.formatValue(Number(value)) }</td>);
            }),
            sum: sum
        }
    };

    render() {
        let summaryTable = this.getInstanceProperty('SUMMARY_TABLE');

        let cashFlow = { 0: this.getInstanceProperty('INITIAL_RESERVE') || 0 };
        let monthlyResult = {};

        this.months.forEach((month) => {
            monthlyResult[month] = summaryTable[month]['incomes'] + summaryTable[month]['expenses'];
            cashFlow[month] = cashFlow[month-1] + monthlyResult[month];
        });

        return (
            <div className='table-responsive'>
                <table className='table bg-white text-right'>
                    <thead>
                    <tr>
                        <th></th><th>Rezerva</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th><th>Celkem</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr className='table-primary'>
                        <th>Příjmy</th>
                        <th>-</th>
                        { this.months.map((month) => <th key={month}>{ this.formatValue(summaryTable[month]['incomes']) }</th>) }
                        <th>{ this.formatValue(this.getInstanceProperty('SUMMARY_TOTALS')['incomes']) }</th>
                    </tr>
                    <tr className='table-primary'>
                        <th>Výdaje</th>
                        <th>-</th>
                        { this.months.map((month) => <th key={month}>{ this.formatValue(summaryTable[month]['expenses']) }</th>) }
                        <th>{ this.formatValue(this.getInstanceProperty('SUMMARY_TOTALS')['expenses']) }</th>
                    </tr>
                    <tr className='table-primary'>
                        <th>Měsíční vysledek</th>
                        <th>-</th>
                        { this.months.map((month) => <th key={month}>{ this.formatValue(summaryTable[month]['incomes'] + summaryTable[month]['expenses']) }</th>) }
                        <th>{ this.formatValue(this.getInstanceProperty('SUMMARY_TOTALS')['incomes'] + this.getInstanceProperty('SUMMARY_TOTALS')['expenses']) }</th>
                    </tr>
                    <tr className='table-primary'>
                        <th>Cash Flow</th>
                        { Object.keys(cashFlow).map((index) => <th key={index}>{ this.formatValue(cashFlow[index]) }</th>) }
                        <th>{ this.formatValue(cashFlow[12]) }</th>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableSumRow('Příjmy', (moneyObject) => (moneyObject.type === 'income_active' || moneyObject.type === 'income_passive')) }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableSumRow('Aktivní', (moneyObject) => moneyObject.type === 'income_active') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableRows((moneyObject) => moneyObject.type === 'income_active') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableSumRow('Pasivní', (moneyObject) => moneyObject.type === 'income_passive') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableRows((moneyObject) => moneyObject.type === 'income_passive') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableSumRow('Výdaje a investice', (moneyObject) => (moneyObject.type === 'expense' || moneyObject.type === 'investment')) }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableSumRow('Výdaje', (moneyObject) => moneyObject.type === 'expense') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableRows((moneyObject) => moneyObject.type === 'expense') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableSumRow('Investice', (moneyObject) => moneyObject.type === 'investment') }
                    </tbody>
                    <tbody>
                    <tr>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody>
                    { this.tableRows((moneyObject) => moneyObject.type === 'investment') }
                    </tbody>
                </table>
                <div className='separate-bottom'/>
            </div>
        )
    }
}

function categoryIndex(category) {
    switch (category) {
        case "specific": return 0;
        case "domacnost": return 10;
        case "pece_o_sebe": return 20;
        case "komunikace_a_media": return 30;
        case "zdravi_a_sport": return 40;
        case "vzdelavani_a_rozvoj": return 50;
        case "zabava": return 60;
        case "co_zivot_dal": return 100;
        case "privydelky": return 70;
        case "vanoce": return 80;
        case "financni_rezervy_a_investice": return 90;
    }
}

function mapStateToProps(state,ownProps) {

    let instance = state.gameInstance.instance;
    let money = [];

    if (instance) {
        (instance.properties['PROFILE_RESOURCES'] || []).forEach((resource) => {
            money.push(resource)
        });

        instance
            .answers
            .sort((a,b) => {
                let node = a.luduengine_game_node_id - b.luduengine_game_node_id;

                if (node === 0) {
                    let a_category = a.knowledge_question.properties.category;
                    let b_category = b.knowledge_question.properties.category;
                    let category = categoryIndex(a_category) - categoryIndex(b_category);

                    if (category === 0) {
                        return a.luduengine_knowledge_question_id - b.luduengine_knowledge_question_id;
                    }
                    return category;
                }
                return node;
            })
            .forEach((answer) => {
            let moneyObjects = answer.knowledge_question_option.properties.resources || [];
            moneyObjects
                .filter((resource) => GameInstance.MONEY_RESOURCES.includes(resource['type']))
                .forEach((moneyObject) => {

                if (moneyObject['months'] === undefined || moneyObject['months'] === null) {
                    let selectedMonth = answer.properties['month'] ? Number(answer.properties['month']) : 1;
                    if (moneyObject['repeat']) {
                        moneyObject['months'] = [];
                        for (var i = selectedMonth; i <= 12; i++) { moneyObject['months'].push(i); }
                    } else {
                        moneyObject['months'] = [selectedMonth];
                    }
                }

                money.push({
                    ...moneyObject,
                    category: answer.knowledge_question.properties['category'],
                    name: answer.knowledge_question.name
                });
            });
        });
    }

    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
        money: money
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(SummaryTable);
